import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  jobs: null,
  filteredTotal: 0,
  filters: [],
  loading: false,
  total: 0,
  users: [],
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, users } = payload;

  return {
    ...state,
    jobs: data,
    filteredTotal,
    filters,
    loading: false,
    users,
    total,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
